import { Component } from 'react';

class LinkAccount extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="padding-x-20">
                <div id="onboarding-general-settings">
                    <div className="mt-10">
                        {this.props.available_accounts?.map((item, i) => (
                            <div key={i} className="onboarding-step-1">
                                <div className="d-flex align-items-center">
                                    <div
                                        className="onboarding-step-1-img"
                                        style={{
                                            backgroundImage: `url(${item.account_picture})`,
                                        }}
                                    ></div>
                                    <span className="linked-users-span">{item.account_email}</span>
                                </div>
                                <div className="d-flex align-items-center onboarding-step-1-button">
                                    <button
                                        className="button button-filled button-primary width-sm btn ml-10 mt-0"
                                        title="Add Domain"
                                        onClick={() => this.props.selectAccount(item)}
                                    >
                                        Use This GCS Account
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default LinkAccount;
